export enum Pos {
    DEFAULT = 1,
    QUICKBOOKS = 2,
    VEND = 3,
    SAGE = 4,
    PASTEL = 5,
    LIGHTSPEED = 6
}
